import Highcharts from "highcharts";
import { useMemo } from "react";
import BaseScoringChart from "./BaseScoringChart";

export const BAR_DIRECTION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
};

export default function BarChart({ series, categories, isLoading, option, type = BAR_DIRECTION.VERTICAL, ...props }) {
  const _plotOption = {
    borderWidth: 0,
    borderRadius: 2,
    pointWidth: 8,
  };

  const options = useMemo(() => {
    let _type = "column";
    let _plotOptions = { column: _plotOption };
    if (type === BAR_DIRECTION.HORIZONTAL) {
      _type = "bar";
      _plotOptions = { bar: _plotOption };
    }
    return Highcharts.merge(
      {
        chart: {
          type: _type,
        },
        title: {
          text: undefined,
        },
        xAxis: {
          categories: categories,
        },
        yAxis: {
          title: {
            text: undefined,
          },
          gridLineWidth: 0,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          ..._plotOptions,
          ...{
            series: {
              pointWidth: 20,
            },
          },
        },
        series: series,
      },
      option
    );
  }, [categories, series, option, type]);

  return <BaseScoringChart isLoading={isLoading} highcharts={Highcharts} options={options} {...props} />;
}
